import React from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { useDetectLanguage } from 'js/hooks/user';
import { WebContent } from 'js/components/system/WebContent';

export const MaintenancePage: React.FC = () => {
    const { webContentId } = useAppSelector(prop('maintenance'));

    useDetectLanguage();

    return <WebContent id={webContentId} showLoader={false} />;
};
